import React, { FC, useEffect } from 'react'
import { useStoreActions, useStoreState } from 'store'
import useVisibility from '../../../hooks/useVisibility'

const HelpDeskRow: FC = () => {
  const isDesktop = useStoreState(state => state.dimensions.isDesktop)
  const [isVisible, element] = useVisibility()
  const { onClickTracking } = useStoreActions(actions => actions.tracking)
  const onViewedTracking = useStoreActions(actions => actions.tracking).onViewedTracking
  const activeDisplayTab = useStoreState(state => state.dimensions.activeDisplayTab)

  useEffect(() => {
    if (isVisible) {
      onViewedTracking({
        element: {
          type: 'button',
          location: 'Banner',
          position: String(activeDisplayTab),
          text: isDesktop ? 'Call (855) 849-5803' : 'Call (855) 837-6575',
          name: 'Help Desk Banner',
        },
      })
    }
  })

  const clickHandler = async () => {
    onClickTracking({
      element: {
        type: 'Link',
        location: 'Banner',
        position: 'All Results',
        text: 'Call (855) 837-6575',
        name: 'Help Desk Banner',
      },
      outcome: 'Phone call',
    })
  }

  return (
    <tr ref={element} className="rate-table__row bg-white" data-testid="help-desk-row">
      <td className="md:px-0 w-full" colSpan={6}>
        <div
          className="display-flex align-items-center bg-blue-light py-8"
          data-testid="help-desk"
          style={{
            backgroundImage: `url("https://www.bankrate.com/2021/05/26114740/background-dashed-line.png")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 100%',
          }}
        >
          <div className="sm:w-2/3 sm:text-left">
            <div className="md:pl-32 sm:ml-16">
              <p className="type-body-one font-circular-bold mb-2">Too many options? Skip the comparison.</p>
              <p className="type-body-one sm:mb-0">
                Call us now and instantly get in touch with a mortgage lender in your area.
              </p>
            </div>
          </div>
          <div className="sm:w-1/3 sm:text-left">
            {!isDesktop ? (
              <a href="tel: 855-837-6575" className="Button Button--secondary" onClick={clickHandler}>
                <svg
                  className="Icon Icon--xs mr-1 fill-black"
                  style={{ top: '-5px' }}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  focusable="false"
                >
                  <title>Phone icon</title>
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.26386 8.83989C6.28815 7.69501 5.28078 5.86631 5.30352 5.61415C5.30605 5.58611 5.80819 5.38527 6.20226 5.07693C6.40775 4.91615 6.68574 4.63874 6.90475 4.41001C7.1143 4.19118 7.14854 3.85613 6.9884 3.5978L5.0694 0.502855C4.7269 -0.049519 3.98254 -0.167237 3.49082 0.251753L2.21512 1.33879C0.936658 2.42818 0.626971 4.29026 1.47755 5.74846C2.41549 7.35644 2.74455 8.21104 4.90484 10.85C7.06511 13.489 7.86059 13.9462 9.2571 15.1634C10.5235 16.2672 12.3831 16.2809 13.6616 15.1915L14.9373 14.1045C15.4297 13.6849 15.4435 12.9201 14.9679 12.4822L12.2997 10.0257C12.077 9.82064 11.7461 9.79672 11.4975 9.96827C11.2377 10.1476 10.9204 10.3774 10.7288 10.555C10.3613 10.8955 10.0793 11.3629 10.0517 11.3605C9.80324 11.3395 8.23958 9.98475 7.26386 8.83989Z"
                  ></path>
                </svg>
                Call (855) 837-6575
              </a>
            ) : (
              <div className="button secondary" style={{ cursor: 'auto' }}>
                <svg
                  className="Icon Icon--xs mr-1 fill-black"
                  style={{ top: '-5px' }}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  focusable="false"
                >
                  <title>Phone icon</title>
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.26386 8.83989C6.28815 7.69501 5.28078 5.86631 5.30352 5.61415C5.30605 5.58611 5.80819 5.38527 6.20226 5.07693C6.40775 4.91615 6.68574 4.63874 6.90475 4.41001C7.1143 4.19118 7.14854 3.85613 6.9884 3.5978L5.0694 0.502855C4.7269 -0.049519 3.98254 -0.167237 3.49082 0.251753L2.21512 1.33879C0.936658 2.42818 0.626971 4.29026 1.47755 5.74846C2.41549 7.35644 2.74455 8.21104 4.90484 10.85C7.06511 13.489 7.86059 13.9462 9.2571 15.1634C10.5235 16.2672 12.3831 16.2809 13.6616 15.1915L14.9373 14.1045C15.4297 13.6849 15.4435 12.9201 14.9679 12.4822L12.2997 10.0257C12.077 9.82064 11.7461 9.79672 11.4975 9.96827C11.2377 10.1476 10.9204 10.3774 10.7288 10.555C10.3613 10.8955 10.0793 11.3629 10.0517 11.3605C9.80324 11.3395 8.23958 9.98475 7.26386 8.83989Z"
                  ></path>
                </svg>
                Call (855) 849-5803
              </div>
            )}
          </div>
        </div>
      </td>
    </tr>
  )
}

export default HelpDeskRow
